import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M7.333 3c.737 0 1.334.62 1.334 1.385v15.23C8.667 20.38 8.07 21 7.333 21 6.597 21 6 20.38 6 19.615V4.385C6 3.62 6.597 3 7.333 3m9.334 0C17.403 3 18 3.62 18 4.385v15.23C18 20.38 17.403 21 16.667 21c-.737 0-1.334-.62-1.334-1.385V4.385c0-.765.597-1.385 1.334-1.385"
    }, null, -1)
  ])))
}
export default { render: render }